import { render, staticRenderFns } from "./AdminBaseSetting.vue?vue&type=template&id=230c4b7e&scoped=true"
import script from "./AdminBaseSetting.vue?vue&type=script&lang=js"
export * from "./AdminBaseSetting.vue?vue&type=script&lang=js"
import style0 from "./AdminBaseSetting.vue?vue&type=style&index=0&id=230c4b7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230c4b7e",
  null
  
)

export default component.exports